import React from "react"
import cx from "classnames"

export const NoResults = ({ className }) => (
  <div className={cx("p-4 bg-gray-200 border-t border-b border-solid border-gray-400", className)}>
    No results found
  </div>
)
